import type { CustomerSearchBatchAction } from '@super-mega/server/contracts/customer'

export const CUSTOMER_BATCH_ACTIONS: Record<
  CustomerSearchBatchAction['action'],
  { label: string; danger?: boolean; description: string }
> = {
  'add-tags': { label: '批量添加客户标签', description: '保留已有标签，重复标签自动跳过；每个客户最多 50 个标签。' },
  'clear-tags': { label: '清空客户标签', danger: true, description: '移除匹配客户的全部标签关联，保留标签目录。' },
  'monthly-billing': { label: '设置自动每月生成账单', description: '统一替换匹配客户的月度账单设置，已有账单保留。' },
  enable: { label: '批量恢复', description: '恢复匹配客户，使其可继续用于业务。' },
  disable: { label: '批量停用', danger: true, description: '停用匹配客户，历史数据保留。' },
  delete: {
    label: '批量删除',
    danger: true,
    description: '仅删除已停用客户；采用软删除，历史关联数据保留。不符合条件的客户计为失败。'
  }
}

export const CUSTOMER_BATCH_MENU_ITEMS = Object.entries(CUSTOMER_BATCH_ACTIONS).map(([key, item]) => ({
  key,
  label: item.label,
  danger: item.danger
}))
